﻿(function () {
    'use strict';

    var serviceId = 'repository.authTokenManager';

    angular
        .module('app.services')
        .factory(serviceId, authTokenManager);

    authTokenManager.$inject = ['$http', 'common', 'repository.abstract'];

    function authTokenManager($http, datacontext, common, abstractRepository) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getRefreshTokens = getRefreshTokens;
            this.deleteRefreshTokens = deleteRefreshTokens;
        }
        abstractRepository.extend(Ctor);

        return Ctor;

        function getRefreshTokens() {

            return $http.get(config.Base_Path_Security + 'refreshtokens').then(function (results) {
                return results;
            });
        };

        function deleteRefreshTokens(tokenid) {

            return $http.delete(config.Base_Path_Security + 'refreshtokens/?tokenid=' + tokenid).then(function (results) {
                return results;
            });
        };

    }
})();